import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import Helmet from 'react-helmet';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
import { Tabs, Tab } from 'material-ui/Tabs';
import { ImagePickerImages, ImagePickerUpload, ImagePickerPixabay, ImagePickerURL, ImagePickerSaved } from 'components/ImagePicker';
import { addImage, init, uploadImages, uploadImageURL, getRecentImages } from 'redux/modules/imagePicker';
import { connect, ReactReduxContext, Provider } from 'react-redux';
var ImagePickerContainer = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  return {
    user: state.auth.user,
    organization: state.organization.current,
    selectedstockimages: state.imagePicker.selectedstockimages,
    selectedsavedimages: state.imagePicker.selectedsavedimages,
    uploadedImages: state.imagePicker.uploadedImages,
    uploadedURLImages: state.imagePicker.uploadedURLImages,
    urlString: state.imagePicker.urlString,
    hasValidUrlLink: state.imagePicker.hasValidUrlLink,
    uploadingImage: state.imagePicker.uploadingImage,
    fileUploadError: state.imagePicker.fileUploadError
  };
}, {
  addImage: addImage,
  init: init,
  uploadImages: uploadImages,
  uploadImageURL: uploadImageURL,
  getRecentImages: getRecentImages
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(ImagePickerContainer, _Component);

  var _super = _createSuper(ImagePickerContainer);

  function ImagePickerContainer(props) {
    var _this;

    _classCallCheck(this, ImagePickerContainer);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getImages", function () {
      _this.props.getRecentImages(_this.props.organization.id);
    });

    _defineProperty(_assertThisInitialized(_this), "addImage", function (selectedImage) {
      _this.props.addImage(selectedImage, _this.state.tab, _this.props.maxImageCount);
    });

    _defineProperty(_assertThisInitialized(_this), "handleStockImageInsert", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var images, index, res;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              images = [];
              index = 0;

            case 2:
              if (!(index < _this.props.selectedstockimages.length)) {
                _context.next = 15;
                break;
              }

              _context.prev = 3;
              _context.next = 6;
              return _this.props.uploadImageURL(_this.props.selectedstockimages[index].largeImageURL, _this.props.organization.id);

            case 6:
              res = _context.sent;
              images.push(res.data);
              _context.next = 12;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](3);

            case 12:
              index++;
              _context.next = 2;
              break;

            case 15:
              _this.props.parentImageHandler(images);

              _this.resetState();

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 10]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "handleSavedImageInsert", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var images, index, res;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              images = [];
              index = 0;

            case 2:
              if (!(index < _this.props.selectedsavedimages.length)) {
                _context2.next = 15;
                break;
              }

              _context2.prev = 3;
              _context2.next = 6;
              return _this.props.uploadImageURL(_this.props.selectedsavedimages[index].S3Files[0].fullyQualifiedUrl, _this.props.organization.id, _this.props.selectedsavedimages[index].id);

            case 6:
              res = _context2.sent;
              images.push(res.data);
              _context2.next = 12;
              break;

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](3);

            case 12:
              index++;
              _context2.next = 2;
              break;

            case 15:
              _this.props.parentImageHandler(images);

              _this.resetState();

            case 17:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[3, 10]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "handleUrlInsert", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var res, image;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return _this.props.uploadImageURL(_this.props.urlString, _this.props.organization.id);

            case 3:
              res = _context3.sent;
              image = [res.data];

              _this.props.parentImageHandler(image);

              _this.resetState();

              _context3.next = 11;
              break;

            case 9:
              _context3.prev = 9;
              _context3.t0 = _context3["catch"](0);

            case 11:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 9]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "resetState", function () {
      _this.setState({
        open: false,
        stockImageSearchTerm: '',
        tab: 'stock'
      });

      _this.props.init();
    });

    _this.state = {
      open: false,
      stockImageSearchTerm: '',
      tab: 'stock'
    };
    return _this;
  }

  _createClass(ImagePickerContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getImages();
    }
  }, {
    key: "render",
    value:
    /** *********************************************************
     RENDER
     ***********************************************************/
    function render() {
      var _this2 = this;

      var modalTitle = 'Select An Image';
      var tabStyle = {
        color: '#555555',
        textTransform: 'none',
        fontWeight: 300
      };
      var activeTabStyle = Object.assign({}, tabStyle, {
        fontWeight: 700,
        color: '#000000'
      }); // START DIALOG BUTTONS

      var actions = [/*#__PURE__*/React.createElement(RaisedButton, {
        disabled: this.props.uploadingImage,
        label: "Cancel",
        onClick: this.resetState,
        style: {
          marginRight: 24
        }
      })];

      if (this.state.tab === 'stock') {
        actions.push( /*#__PURE__*/React.createElement(RaisedButton, {
          secondary: true,
          disabled: !this.props.selectedstockimages.length || this.props.uploadingImage,
          label: this.props.uploadingImage ? /*#__PURE__*/React.createElement("i", {
            className: "fa fa-spin fa-spinner",
            style: {
              fontSize: 20
            }
          }) : 'Insert',
          onClick: function onClick() {
            _this2.handleStockImageInsert();
          }
        }));
      } else if (this.state.tab === 'saved') {
        actions.push( /*#__PURE__*/React.createElement(RaisedButton, {
          secondary: true,
          disabled: !this.props.selectedsavedimages.length || this.props.uploadingImage,
          label: this.props.uploadingImage ? /*#__PURE__*/React.createElement("i", {
            className: "fa fa-spin fa-spinner",
            style: {
              fontSize: 20
            }
          }) : 'Insert',
          onClick: function onClick() {
            _this2.handleSavedImageInsert();
          }
        }));
      } else if (this.state.tab === 'url') {
        actions.push( /*#__PURE__*/React.createElement(RaisedButton, {
          secondary: true,
          disabled: !this.props.hasValidUrlLink || this.props.uploadingImage,
          label: this.props.uploadingImage ? /*#__PURE__*/React.createElement("i", {
            className: "fa fa-spin fa-spinner",
            style: {
              fontSize: 20
            }
          }) : 'Insert',
          onClick: function onClick() {
            _this2.handleUrlInsert();
          }
        }));
      } else {
        actions.push( /*#__PURE__*/React.createElement(RaisedButton, {
          secondary: true,
          disabled: !this.props.uploadedImages.length || this.props.uploadingImage,
          label: this.props.uploadingImage ? /*#__PURE__*/React.createElement("i", {
            className: "fa fa-spin fa-spinner",
            style: {
              fontSize: 20
            }
          }) : 'Insert',
          onClick: function onClick() {
            _this2.props.parentImageHandler(_this2.props.uploadedImages);

            _this2.resetState();
          }
        }));
      } // END DIALOG BUTTONS


      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(RaisedButton, {
        secondary: true,
        label: this.props.buttonText,
        onClick: function onClick() {
          _this2.setState({
            open: true
          });
        }
      }), /*#__PURE__*/React.createElement(ReactReduxContext.Consumer, null, function (ctx) {
        return /*#__PURE__*/React.createElement(Dialog, {
          repositionOnUpdate: false,
          modal: true,
          actions: actions,
          autoScrollBodyContent: true,
          bodyStyle: {
            padding: 0
          },
          contentStyle: {
            maxWidth: 685,
            paddingTop: 0,
            transform: 'none'
          },
          open: _this2.state.open,
          onRequestClose: function onRequestClose() {
            _this2.setState({
              open: false
            });
          },
          style: {
            paddingTop: 16
          },
          title: modalTitle,
          titleStyle: {
            borderBottom: 0,
            paddingBottom: 6
          }
        }, /*#__PURE__*/React.createElement(Provider, {
          store: ctx.store
        }, /*#__PURE__*/React.createElement(Tabs, {
          value: _this2.state.tab,
          onChange: function onChange(tab) {
            _this2.setState({
              tab: tab
            });
          },
          tabTemplateStyle: {
            backgroundColor: 'white'
          },
          tabItemContainerStyle: {
            backgroundColor: 'white'
          }
        }, /*#__PURE__*/React.createElement(Tab, {
          label: "Stock Images",
          value: "stock",
          style: _this2.state.tab === 'stock' ? activeTabStyle : tabStyle
        }, /*#__PURE__*/React.createElement(ImagePickerPixabay, {
          maxImageCount: _this2.props.maxImageCount,
          selectedImages: _this2.props.selectedstockimages,
          handleSelectImage: _this2.addImage
        })), /*#__PURE__*/React.createElement(Tab, {
          label: "Recent Images",
          value: "saved",
          style: _this2.state.tab === 'saved' ? activeTabStyle : tabStyle
        }, /*#__PURE__*/React.createElement(ImagePickerSaved, {
          maxImageCount: _this2.props.maxImageCount,
          selectedImages: _this2.props.selectedsavedimages,
          handleSelectImage: _this2.addImage,
          organization: _this2.props.organization,
          user: _this2.props.user
        })), /*#__PURE__*/React.createElement(Tab, {
          label: "Upload From URL",
          value: "url",
          style: _this2.state.tab === 'url' ? activeTabStyle : tabStyle
        }, /*#__PURE__*/React.createElement(ImagePickerURL, {
          organization: _this2.props.organization
        })), /*#__PURE__*/React.createElement(Tab, {
          label: "Upload Image",
          value: "upload",
          style: _this2.state.tab === 'upload' ? activeTabStyle : tabStyle
        }, /*#__PURE__*/React.createElement(ImagePickerUpload, {
          maxImageCount: _this2.props.maxImageCount,
          organization: _this2.props.organization,
          uploadImages: _this2.props.uploadImages,
          uploadingImage: _this2.props.uploadingImage,
          fileUploadError: _this2.props.fileUploadError,
          parentImageHandler: _this2.props.parentImageHandler,
          resetState: _this2.resetState,
          uploadedImages: _this2.props.uploadedImages
        })))), /*#__PURE__*/React.createElement("div", null));
      }));
    }
  }]);

  return ImagePickerContainer;
}(Component)) || _class);
export { ImagePickerContainer as default };
ImagePickerContainer.defaultProps = {
  parentImageHandler: function parentImageHandler() {
    console.log('do something with the images, parent!');
  },
  buttonText: 'Choose Image',
  maxImageCount: 1
};